<script>
 import Ekleme from './Ekleme.svelte'
 import Tercume from './Tercume.svelte'
 import Rastgele from './Rastgele.svelte'

 import {cümleÇevirileriniGöster}  from './kasa.js'

 let cümleÇevirisiGöster

 cümleÇevirileriniGöster.subscribe(değer => {
	 cümleÇevirisiGöster = değer;
 });


</script>
<div class="icerik">
  <div class="satır">
    <div class="sütun-1 sütun-k-2 boşlukYok">
      <a id="öncekiCümle" class="önceki gezinme gezinmeBüyük yuvarlak altBoşluk" href="/cumle/goster/106">&#8249;</a>
    </div>

    <div class="sütun-10 sütun-k-8 boşlukYok">
      <!-- Rastgele cümle -->
      <Rastgele />

      <!-- Ekleme bölümü -->
      <Ekleme />

      <!-- Çeviriler bölümü -->
      {#if $cümleÇevirileriniGöster}
        <Tercume />
      {/if}

    </div>

    <div class="sütun-1 sütun-k-2 boşlukYok ">

      <a id="sonrakiCümleSon" class="sonraki gezinme gezinmeBüyük yuvarlak altBoşluk" href="/">.</a>


    </div>
  </div>
</div>
